import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { device } from './Elements';

const Container = styled.main`
  padding: 10px 40px;
  margin-bottom: 20px;
  @media ${device.tablet} {
    padding: 10px 200px;
  }

  &:focus {
    outline: none;
  }
`;

const Footer = styled.footer`
  padding: 10px 40px 20px;
  font-size: 0.8rem;
  @media ${device.tablet} {
    padding: 10px 200px 20px;
  }
`;

export const Layout = ({ children }) => {
  const mainRef = useRef(null);

  useEffect(() => {
    mainRef.current?.focus();
  }, []);

  return (
    <>
      <Container ref={mainRef} tabIndex={-1}>
        {children}
      </Container>
      <Footer>
        <Link to='/privacy'>Privacy Policy</Link>
      </Footer>
    </>
  );
};
